var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { FTLButton } from "../FTLButton";
import { makeStyles } from "@material-ui/core";
import classNames from "classnames";
export const FTLPaginationButton = React.forwardRef((_a, ref) => {
    var { isSelected = false, className } = _a, otherProps = __rest(_a, ["isSelected", "className"]);
    const classes = useStyles();
    return (React.createElement(FTLButton, Object.assign({ ref: ref, isSelected: isSelected, color: "secondary", className: classNames(classes.button, className) }, otherProps)));
});
const useStyles = makeStyles({
    button: {
        transition: "none",
    },
});
//# sourceMappingURL=FTLPaginationButton.js.map